import React, { useState } from "react";
import "../MobileCoinAllotmentHeader/MobileCoinAllotHeader.css";
import { FaSearch, FaFilter } from "react-icons/fa";
import MobileCoinAllotFilterPopup from "./MobileCoinAllotFilterPopup/MobileCoinAllotFilterPopup";

const MobileCoinAllotHeader = ({
  search,
  setSearch,
  columnSearch,
  setColumnSearch,
  onRefresh,
  totals,
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const handleRefresh = () => {
    setSearch("");
    setColumnSearch({
      status: "active",
      customerName: "",
      mobile: "",
      coins: "",
      createdBy: "",
      companyName: "",
      lastLoginStartDate: null,
      lastLoginEndDate: null,
      lastTransactionStartDate: null,
      lastTransactionEndDate: null,
      lastLogin: "",
      lastTransaction: "",
      reference: "",
      address: "",
      mapLocation: "",
    });
    if (onRefresh) onRefresh();
  };

  const getTotalColorClass = () => {
    if (columnSearch.status === "active") return "total-green";
    if (columnSearch.status === "deactive") return "total-red";
    return "total-green";
  };

  return (
    <>
      <div
        className={`mobile-customer-header-wrapper ${
          showFilterPopup ? "blur-background" : ""
        }`}
      >
        <div className="mobile-header">
          <div className="mobile-search-container">
            <FaSearch className="mobile-search-icon" />
            <input
              type="text"
              placeholder="Search here..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="mobile-search-input"
            />
          </div>

          <div className={`mobile-total-coins ${getTotalColorClass()}`}>
            <span>Total:</span>
            <strong>{totals?.net || 0}</strong>
          </div>

          <FaFilter
            className="mobile-filter-icon"
            onClick={() => setShowFilterPopup(true)}
          />
        </div>
      </div>

      {showFilterPopup && (
        <MobileCoinAllotFilterPopup
          onClose={() => setShowFilterPopup(false)}
          columnSearch={columnSearch}
          setColumnSearch={setColumnSearch}
          handleRefresh={handleRefresh}
          onAdd={() => setShowOverlay(true)}
        />
      )}
    </>
  );
};

export default MobileCoinAllotHeader;
